export const DESKTOP_LOGO_SIZE = 123;
export const DESKTOP_COLLAPSED_LOGO_SIZE = 42;
export const MOBILE_LOGO_SIZE = 80;

export const MOBILE_MEMBER_IMAGE_SIZE = 278;
export const DESKTOP_MEMBER_IMAGE_SIZE = 360;
